import { api } from "@/lib/api";

export const storageService = {
  getSignedUrl: (key: string, expiresIn?: number) =>
    api.get<{ url: string; key: string }>("/storage/signed-url", {
      key,
      expiresIn,
    }),

  uploadFile: async (file: File, folder = "expenses"): Promise<string> => {
    const formData = new FormData();
    formData.append("files", file);
    formData.append("folder", folder);
    const res = await api.post<{ items: { key: string }[] }>(
      "/storage/upload",
      formData,
    );
    if (!res?.items?.[0]?.key) {
      throw new Error(`Upload file gagal: respon server tidak valid`);
    }
    return res.items[0].key;
  },

  uploadMultipleFiles: async (
    files: File[],
    folder = "expenses",
  ): Promise<string[]> => {
    if (files.length === 0) return [];
    const formData = new FormData();
    for (const file of files) {
      formData.append("files", file);
    }
    formData.append("folder", folder);
    const res = await api.post<{ items: { key: string }[] }>(
      "/storage/upload",
      formData,
    );
    if (!res?.items) {
      throw new Error(`Upload berkas gagal: respon server tidak valid`);
    }
    return res.items.map((item) => item.key);
  },
};
